export default {
    PtSelectMenu: {
        selected: 'Selected',
        deselect: 'Deselect all',
    },
};
